import { Typography, type TypographyProps, styled } from "@mui/material"
import { formatDateWithDots } from "@pharmupp/p3-front-commons"

export const SyncDate = ({
  date,
  label = "Données du",
  ...props
}: { date?: string; label?: string } & TypographyProps) => (
  <SyncDateContainer {...props}>
    {label} <SyncDateValue>{date && formatDateWithDots(date)}</SyncDateValue>
  </SyncDateContainer>
)

const SyncDateContainer = styled(Typography)(
  ({ theme: { palette, typography } }) => ({
    color: palette.grey.light,
    fontSize: typography.pxToRem(12),
    textAlign: "right",
  }),
)

const SyncDateValue = styled("span")({
  fontSize: "inherit",
  fontWeight: 600,
})
